(() => {
  const searchDialog = document.getElementById('search-dialog');
  let searchTrigger = null;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-search]');
    if (opener && searchDialog) {
      searchTrigger = opener;
      searchDialog.showModal();
      searchDialog.querySelector('input[type="search"]')?.focus();
      return;
    }
    if (event.target.closest('[data-close-dialog]')) {
      event.target.closest('dialog')?.close();
      return;
    }
    if (event.target === searchDialog) searchDialog.close();
    document.querySelectorAll('[data-mobile-menu][open], [data-nav-drop][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
  searchDialog?.addEventListener('close', () => searchTrigger?.focus());

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const drops = [...document.querySelectorAll('.desktop-nav [data-nav-drop][open]')];
    const targets = drops.length ? drops : [...document.querySelectorAll('[data-mobile-menu][open]')];
    targets.forEach((menu) => {
      menu.removeAttribute('open');
      menu.querySelector('summary')?.focus();
    });
  });

  const desktopNav = document.querySelector('.desktop-nav');
  const canHover = matchMedia('(hover: hover) and (min-width: 1100px)');
  let closeTimer = 0;
  const closeDrops = (except) => {
    desktopNav?.querySelectorAll('[data-nav-drop][open]').forEach((drop) => {
      if (drop !== except) drop.removeAttribute('open');
    });
  };
  desktopNav?.querySelectorAll('.nav-drop').forEach((item) => {
    const drop = item.querySelector('[data-nav-drop]');
    item.addEventListener('mouseenter', () => {
      if (!canHover.matches) return;
      clearTimeout(closeTimer);
      closeDrops(drop);
      drop.setAttribute('open', '');
    });
    item.addEventListener('mouseleave', () => {
      if (!canHover.matches) return;
      closeTimer = setTimeout(() => drop.removeAttribute('open'), 180);
    });
    drop.addEventListener('toggle', () => {
      if (drop.open) closeDrops(drop);
    });
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) drop.removeAttribute('open');
    });
  });
  document.querySelectorAll('.mobile-menu__links [data-nav-drop]').forEach((drop) => {
    drop.addEventListener('toggle', () => {
      if (!drop.open) return;
      drop.closest('.mobile-menu__panel')?.scrollTo({ top: 0 });
      document.querySelectorAll('.mobile-menu__links [data-nav-drop][open]').forEach((other) => {
        if (other !== drop) other.removeAttribute('open');
      });
    });
  });

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-collection-form]')) return;
    event.target.querySelectorAll('input, select').forEach((field) => {
      if (field.name && field.value === '' && field.type !== 'checkbox') field.disabled = true;
    });
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-size-filter]') && event.target.checked) {
      const available = event.target.form?.querySelector('input[name="filter.v.availability"][value="1"]');
      if (available && !available.disabled) available.checked = true;
    }
    if (event.target.matches('[data-auto-submit]')) event.target.form?.requestSubmit();
    if (event.target.matches('[data-campaign-select]')) {
      const option = event.target.selectedOptions[0];
      const price = event.target.closest('[data-campaign]')?.querySelector('[data-campaign-price]');
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
    }
  });

  function initGallery(gallery) {
    const track = gallery.querySelector('[data-gallery-track]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const counter = gallery.querySelector('[data-gallery-current]');
    if (!track) return;
    const slides = [...track.querySelectorAll('[data-media-id]')];
    const setCurrent = (index) => {
      thumbs.forEach((thumb, position) => {
        if (position === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = String(index + 1);
    };
    const show = (mediaId) => {
      const index = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index < 0) return;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      setCurrent(index);
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(thumb.dataset.galleryThumb)));
    let frame = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        setCurrent(Math.min(index, slides.length - 1));
      });
    }, { passive: true });
    gallery.showMedia = show;
  }

  function initProduct(root) {
    const dataScript = root.querySelector('[data-variants]');
    const picker = root.querySelector('[data-variant-picker]');
    const select = root.querySelector('[data-variant-select]');
    if (!dataScript || !picker || !select) return;
    const variants = JSON.parse(dataScript.textContent);
    const fieldsets = [...picker.querySelectorAll('fieldset[data-option-index]')];
    const button = root.querySelector('[data-add-button]');
    const label = root.querySelector('[data-add-label]');
    const status = root.querySelector('[data-variant-status]');
    const priceWrapper = root.querySelector('[data-price-wrapper]');
    const priceEl = priceWrapper?.querySelector('[data-price]');
    const compareEl = priceWrapper?.querySelector('[data-compare]');
    const compareAmount = priceWrapper?.querySelector('[data-compare-amount]');
    const showCompare = priceWrapper?.dataset.showCompare === 'true';
    const gallery = root.querySelector('[data-gallery]');
    const current = variants.find((variant) => String(variant.id) === select.value) || variants[0];
    const preselected = root.dataset.selectedVariant === 'true';
    const chosen = current.options.map((value, index) => preselected || !fieldsets.some((field) => Number(field.dataset.optionIndex) === index) ? value : null);
    const alternative = root.querySelector('[data-size-alternative]');
    const alternativeBase = alternative?.href;
    const updateAlternative = (unavailable) => {
      if (!alternative) return;
      const size = chosen[Number(alternative.dataset.sizeIndex)];
      alternative.hidden = !unavailable || size === null;
      if (alternative.hidden) return;
      const destination = new URL(alternativeBase, window.location.origin);
      destination.searchParams.set(alternative.dataset.filterParam, size);
      if (alternative.dataset.availabilityParam) destination.searchParams.set(alternative.dataset.availabilityParam, '1');
      if (alternative.dataset.typeParam) destination.searchParams.set(alternative.dataset.typeParam, alternative.dataset.productType);
      alternative.href = destination.href;
    };

    picker.hidden = false;
    root.querySelector('[data-variant-native]').hidden = true;

    const matches = (variant, index, value) => variant.options.every((option, position) => {
      if (position === index) return option === value;
      const fieldset = fieldsets.find((item) => Number(item.dataset.optionIndex) === position);
      return !fieldset || chosen[position] === null || option === chosen[position];
    });

    const render = () => {
      fieldsets.forEach((fieldset) => {
        const index = Number(fieldset.dataset.optionIndex);
        fieldset.querySelectorAll('.option__value').forEach((item) => {
          const input = item.querySelector('input');
          const available = variants.some((variant) => variant.available && matches(variant, index, input.value));
          item.toggleAttribute('data-unavailable', !available);
          const hint = item.querySelector('[data-unavailable-text]');
          if (hint) hint.textContent = available ? '' : ', esaurita';
          if (input.checked) {
            const selected = fieldset.querySelector('[data-option-selected]');
            if (selected) selected.textContent = `: ${item.textContent.replace(', esaurita', '').trim()}`;
          }
        });
      });

      if (chosen.includes(null)) {
        updateAlternative(false);
        select.value = '';
        button.disabled = true;
        label.textContent = fieldsets.length === 1 ? 'Scegli la taglia' : 'Scegli le opzioni';
        status.textContent = '';
        return;
      }
      const variant = variants.find((item) => item.options.every((option, index) => option === chosen[index]));
      if (!variant) {
        updateAlternative(true);
        select.value = '';
        button.disabled = true;
        label.textContent = 'Combinazione non disponibile';
        status.textContent = 'Questa combinazione non esiste. Scegli un’altra opzione.';
        return;
      }
      select.value = String(variant.id);
      const priced = variant.priceCents > 0;
      const buyable = variant.available && priced;
      updateAlternative(!variant.available);
      button.disabled = !buyable;
      label.textContent = !priced ? 'Prezzo da verificare' : variant.available ? 'Aggiungi al carrello' : 'Esaurito';
      status.textContent = !priced ? 'Contatta il negozio per il prezzo.' : variant.available ? '' : 'Questa taglia è esaurita. Scegline un’altra o scrivici.';
      if (priceEl) priceEl.textContent = priced ? variant.price : 'Prezzo da verificare';
      if (compareEl) {
        const hasCompare = showCompare && variant.compareCents > variant.priceCents;
        compareEl.hidden = !hasCompare;
        if (hasCompare && compareAmount) compareAmount.textContent = variant.compare;
      }
      if (variant.media && gallery?.showMedia) gallery.showMedia(variant.media);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    picker.addEventListener('change', (event) => {
      const fieldset = event.target.closest('fieldset[data-option-index]');
      if (!fieldset) return;
      chosen[Number(fieldset.dataset.optionIndex)] = event.target.value;
      render();
    });
    render();
  }

  function initMobilePurchase(root) {
    const bar = root.querySelector('[data-mobile-purchase]');
    const form = root.querySelector('.product-form');
    const original = root.querySelector('[data-add-button]');
    if (!bar || !form || !original || bar.dataset.initialized) return;
    bar.dataset.initialized = 'true';
    const action = bar.querySelector('[data-mobile-buy]');
    const price = root.querySelector('[data-price]');
    const priceCopy = bar.querySelector('[data-mobile-price]');
    const mobile = matchMedia('(max-width: 759px)');
    const update = () => {
      bar.hidden = !mobile.matches || original.getBoundingClientRect().bottom > 0;
      const busy = form.dataset.submitting === 'true';
      const hasOptions = !!form.querySelector('[data-variant-select]');
      action.disabled = busy || (!hasOptions && original.disabled);
      action.textContent = busy ? 'Aggiunta…' : original.disabled && hasOptions ? 'Scegli la taglia' : root.querySelector('[data-add-label]').textContent.trim();
      if (price) priceCopy.textContent = price.textContent;
    };
    let frame = 0;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    };
    const observer = new MutationObserver(update);
    observer.observe(form, {attributes: true, childList: true, characterData: true, subtree: true});
    if (price) observer.observe(price, {childList: true, characterData: true, subtree: true});
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    action.addEventListener('click', () => {
      if (form.dataset.submitting === 'true') return;
      if (!original.disabled) {
        form.requestSubmit(original);
        return;
      }
      const picker = form.querySelector('[data-variant-picker]');
      const target = picker?.querySelector('input:not(:disabled)') || form.querySelector('[data-variant-select]');
      (picker || form).scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      target?.focus({preventScroll: true});
    });
    const cleanup = (event) => {
      if (!event.target.contains(root)) return;
      observer.disconnect();
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      document.removeEventListener('shopify:section:unload', cleanup);
    };
    document.addEventListener('shopify:section:unload', cleanup);
    update();
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-product]').forEach(initProduct);
    scope.querySelectorAll('[data-product]').forEach(initMobilePurchase);
  }

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
